/**
 * BRAND CONFIGURATION — Single Source of Truth
 * ============================================
 *
 * Every display string, asset URL and brand identifier visible on the
 * public site, login screens, store portal, admin console and /demo tour
 * reads from this file.
 *
 * 🔒 Do NOT rename CSS class names (`kazo-text-burgundy`, etc.) or the
 *    `--kazo-*` CSS variables — those are stable selectors used across
 *    50+ components. Only the VALUES below change per brand.
 */

export const BRAND = {
  // -- Identity --------------------------------------------------------
  name: "BEVERLY HILLS POLO CLUB",              // Short display name / wordmark
  legalName: "Beverly Hills Polo Club",         // Used in © footer / legal
  domain: "beverlyhillspoloclub.com",           // Public-facing website
  shortDescriptor: "premium fashion & lifestyle brand",
  audience: "the modern connoisseur of style",
  region: "India",
  storesLine: "Across flagship boutiques nationwide",
  headOffice: "Beverly Hills Polo Club, New Delhi, India",
  supportPhone: "1800-000-4567",

  // -- Operational identifiers ----------------------------------------
  couponPrefix: "BH",                           // Coupon code prefix
  posMerchantId: "BEVERLY_HILLS",               // POS (e-wards) merchant id
  smsSenderId: "BVHILL",                        // DLT registered SMS sender ID

  // -- Platform identity (Fundle = the loyalty engine running this app)
  platform: "Fundle",
  poweredBy: "Powered by Fundle",
  aiAssistant: "Fundle Brain",
  platformLogoUrl: "/fundle-logo.png",
  brandLogoUrl: "/bhpc-logo.png",               // black artwork on transparent

  // -- Loyalty programme branding -------------------------------------
  loyaltyProgramName: "Beverly Hills Polo Club Rewards",
  welcomePointsValue: 100,
  welcomeToast: "Welcome to Beverly Hills Polo Club Rewards! 100 bonus points credited.",
  ctaJoinFree: "Join BHPC Rewards Free",

  // -- Social --------------------------------------------------------
  social: {
    instagram: "https://www.instagram.com/bhpcindia/?hl=en",
    facebook: "https://www.facebook.com/beverlyhillspoloclubINDIA/",
    linkedin: "https://www.linkedin.com/company/beverly-hills-polo-club/",
  },

  // -- SEO / meta (also mirror in frontend/public/index.html) ---------
  meta: {
    title: "Beverly Hills Polo Club Rewards — Powered by Fundle",
    description:
      "Join the official Beverly Hills Polo Club loyalty programme. Earn points on every purchase, unlock exclusive tier privileges, birthday bonuses, and access VIP collections. Powered by Fundle.",
  },

  // -- Public home copy (CMS overrides take precedence at runtime) ----
  homeCopy: {
    heroEyebrow: "An Exclusive Programme · Powered by Fundle",
    heroSubtext:
      "The official Beverly Hills Polo Club loyalty programme. Every purchase reveals new privileges — from welcome bonuses and birthday gifts to private VIP previews.",
    heroImageAlt: "Beverly Hills Polo Club premium fashion editorial",
    boutiqueImageAlt: "Beverly Hills Polo Club boutique interior",
    editorialImageAlt: "Model wearing the Beverly Hills Polo Club collection",
  },

  // -- Footer copy ----------------------------------------------------
  footerTagline:
    "The official loyalty programme for Beverly Hills Polo Club — where every purchase becomes a privilege. Designed for the modern connoisseur of style.",

  // -- Login / portal copy --------------------------------------------
  loginCopy: {
    descriptor:
      "A unified suite for loyalty, CRM, analytics and campaigns — purpose-built for Beverly Hills Polo Club.",
    imageAlt: "Beverly Hills Polo Club",
  },

  // -- Brand colour palette ------------------------------------------
  // Injected as CSS variables at runtime (see App.js → useEffect).
  // Variable NAMES stay `--kazo-*`; only the VALUES change per brand.
  // Beverly Hills Polo Club palette: signature navy + champagne gold on cream.
  colors: {
    black: "#0A0A0A",          // --kazo-black           (header / footer)
    cream: "#F6F3EC",          // --kazo-cream           (page background)
    burgundy: "#14304F",       // --kazo-burgundy        (primary brand accent — polo navy)
    burgundyDeep: "#0D2038",   // --kazo-burgundy-deep   (hover state)
    champagne: "#C6A15B",      // --kazo-champagne       (secondary accent — gold)
    champagneLight: "#E4D2A6", // --kazo-champagne-light (light backgrounds)
  },
};

export default BRAND;
